import { useEffect, useState, useRef } from "react";
import api, { formatApiError } from "../lib/api";
import { Plus, Loader2 } from "lucide-react";
import { toast } from "sonner";

// Campo "Tipo ufficio" con autocompletamento e creazione di nuove voci.
// Le voci sono una lista globale (per studio) salvata nel DB e condivisa tra tutte le compagnie.
export default function CreatableTipoUfficio({ value, onChange, testId }) {
  const [opts, setOpts] = useState([]);
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState(value || "");
  const [adding, setAdding] = useState(false);
  const boxRef = useRef(null);
  useEffect(() => { api.get("/studio/tipo-ufficio-options").then(({ data }) => setOpts(Array.isArray(data) ? data : [])).catch(() => setOpts([])); }, []);
  useEffect(() => { setQ(value || ""); }, [value]);
  useEffect(() => {
    const onDoc = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);
  const typed = (q || "").trim();
  const filtered = opts.filter((o) => o.toLowerCase().includes((q || "").toLowerCase()));
  const exists = opts.some((o) => o.toLowerCase() === typed.toLowerCase());
  const pick = (o) => { onChange(o); setQ(o); setOpen(false); };
  const addNew = async () => {
    if (!typed) return;
    setAdding(true);
    try {
      const { data } = await api.post("/studio/tipo-ufficio-options", { value: typed });
      if (Array.isArray(data)) setOpts(data);
      onChange(typed); setQ(typed); setOpen(false);
      toast.success("Voce aggiunta all'elenco");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Errore"); }
    finally { setAdding(false); }
  };
  return (
    <div className="relative mt-1.5" ref={boxRef}>
      <input value={q} autoComplete="off" placeholder="Seleziona o digita una nuova voce…" data-testid={testId}
        onChange={(e) => { setQ(e.target.value); onChange(e.target.value); setOpen(true); }} onFocus={() => setOpen(true)}
        onKeyDown={(e) => { if (e.key === "Enter" && typed && !exists) { e.preventDefault(); addNew(); } }}
        className="h-9 w-full px-3 rounded-md bg-slate-900/60 border border-slate-700 text-sm text-slate-100 placeholder:text-slate-500 focus:outline-none focus:border-cyan-500/50" />
      {open && (
        <div className="absolute z-50 mt-1 w-full max-h-56 overflow-auto rounded-md border border-slate-700 bg-[#121824] shadow-xl py-1" data-testid={`${testId}-menu`}>
          {filtered.map((o) => (
            <button type="button" key={o} onClick={() => pick(o)} data-testid={`${testId}-opt`}
              className={`w-full text-left px-3 py-1.5 text-sm transition-colors ${o === value ? "bg-amber-500/15 text-amber-200" : "text-slate-100 hover:bg-slate-700"}`}>{o}</button>
          ))}
          {typed && !exists && (
            <button type="button" onClick={addNew} disabled={adding} data-testid={`${testId}-add`}
              className="w-full text-left px-3 py-1.5 text-sm text-amber-300 hover:bg-amber-500/10 flex items-center gap-1.5 border-t border-slate-700/60">
              {adding ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Plus className="h-3.5 w-3.5" />} Aggiungi «{typed}»
            </button>
          )}
          {!filtered.length && !typed && <div className="px-3 py-1.5 text-xs text-slate-500">Nessuna voce. Digita per crearne una.</div>}
        </div>
      )}
    </div>
  );
}
